export default class AppClipboard {
    constructor () {
        this.init();
    }

    init () {
        let clipboard = new ClipboardJS('[data-clipboard-text]');
        clipboard.on('success', function (e) {
            let delay = 1000;
            let $trigger = $(e.trigger);
            let $icon = $trigger.find('i');
            $icon
                .removeClass('far')
                .removeClass('text-info')
                .addClass('fas')
                .addClass('text-success');

            $trigger.data('last-trigger', Date.now());
            setTimeout(function () {
                if (Date.now() >= $trigger.data('last-trigger') + delay) {
                    $icon
                        .removeClass('fas')
                        .removeClass('text-success')
                        .addClass('far')
                        .addClass('text-info');
                }
            }, delay);
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/clipboard.js